import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import DevicesGrid from './components/grids/devicesGrid';
import ChargingGrid from './components/grids/chargingGrid';
import ProtectedRoute from './components/protectedRoute';
import GolfMapHandler from './components/handlers/golfMap-handler';
import EnvironGrid from './components/grids/environmentalGrid';
import DashboardGrid from './components/grids/dashboardGrid';
import Toolbar from './components/navigation/toolbar';
import BuildingGrid from './components/grids/powerGrid';
import AccountSettingsGrid from './components/grids/accountSettingsGrid';
import UnderConstruction from './components/grids/underConstructionGrid';
import EventGrid from './components/grids/eventNewsfeedGrid';
import KioskLayout from './components/grids/kioskLayout';
import PrivacyPolicy from './components/grids/privacyPolicy';
import NotificationsHelp from './components/grids/notificationsHelpGrid';
import PaceOfPlayGrid from './components/grids/paceOfPlayGrid';
import TtnSensorRegistrationGrid from './components/grids/ttnSensorRegistrationGrid';
import SensorsAdminGrid from './components/grids/sensorsAdminGrid';
import SensorsEditGrid from './components/grids/sensorsEditGrid';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Router>
        <Routes>
          {/* Outside of Toolbar */}
          <Route path="/kiosk/:BuildingID" element={<KioskLayout />} />
          
          <Route element={<Toolbar />}>
            {/* Root route */}
            <Route path="/" element={<DashboardGrid />}/>
            {/* Other routes */}
            <Route path="/dashboard" element={ <DashboardGrid />}/>
            <Route path="/map" element={<GolfMapHandler />} />
            <Route path="/fleet/map" element={<GolfMapHandler />} />
            <Route path="/fleet/:deviceEUI" element={<GolfMapHandler />} />
            <Route path="/fleet" element={<DevicesGrid />}/>
            <Route
              path="/sensors/register"
              element={(
                <ProtectedRoute allowedRoles={['Admin']}>
                  <TtnSensorRegistrationGrid />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/sensors/manage"
              element={(
                <ProtectedRoute allowedRoles={['Admin']}>
                  <SensorsAdminGrid />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/sensors/edit"
              element={(
                <ProtectedRoute allowedRoles={['Admin']}>
                  <SensorsEditGrid />
                </ProtectedRoute>
              )}
            />
            <Route path="/fleet/charging" element={<UnderConstruction />} />
            <Route path="/fleet/charging/:BuildingID" element={<ChargingGrid />} />
            <Route path="/environment/:Group" element={<EnvironGrid />} />
            <Route path="/maintenance" element={<UnderConstruction />} />
            <Route path="/maintenance/map" element={<UnderConstruction />} />
            <Route path="/power/:BuildingID" element={<BuildingGrid />}/>
            <Route path="/building/:Group" element={<EnvironGrid/>}/>
            <Route path="/events" element={<EventGrid />} />
            <Route path="/account-settings" element={<AccountSettingsGrid />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/notifications/help" element={<NotificationsHelp />} />
            <Route path="*" element={<UnderConstruction />} />
            <Route path="/paceofplay" element={<PaceOfPlayGrid />} />
          </Route>
        </Routes>
      </Router>
    </LocalizationProvider>
  );
}

export default App;


